import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BukkuService {
    constructor(private _apiService: ApiService) {}

    submitBukkuForm(formData: any): Observable<any> {
        return this._apiService.post(API_ENDPOINTS.DIGI_LEADS, formData);
    }
}
